import React from 'react';
import BulletinList from '../../components/bulletin_list/BulletinListContainer';

export default function BulletinListPage() {
  React.useEffect(() => {
    document.title = "Shems Almadina - Bulletins des Commissions"
    return () => {
      document.title = "Shems Almadina"
    };
  }, []);
  return (
    <BulletinList />
  );
}
